import React from "react";
import { render } from "react-dom";
import CustomerRetentionDisount from "../widgets/customer_retention/CustomerRetentionDisount";

// Favourites page
let CustomerRetentionDisountElem = document.querySelector(".widget-customerretentiondiscount");
if (CustomerRetentionDisountElem) render(<CustomerRetentionDisount elem={CustomerRetentionDisountElem} />, CustomerRetentionDisountElem);